<template>
  <v-container>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" md="3">
        <v-btn large block color="success" @click="openProjectDialog"
          >Add project</v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-alert dense outlined type="error" v-show="deleteErrors.length">
          <ul>
            <li v-for="error in deleteErrors" :key="error">{{ error }}</li>
          </ul>
        </v-alert>
        <v-alert
          v-model="showSuccessAlert"
          type="success"
          dismissible
          close-icon="mdi-delete"
          outlined
        >
          Project was created successfully!
        </v-alert>
        <v-alert
          v-model="showUpdateAlert"
          type="success"
          dismissible
          close-icon="mdi-delete"
          outlined
        >
          Project was updated successfully!
        </v-alert>
        <v-alert
          v-model="showDeleteSuccessAlert"
          type="success"
          dismissible
          close-icon="mdi-delete"
          outlined
        >
          Project was deleted successfully!
        </v-alert>
        <v-data-table
          :headers="headers"
          :items="projects"
          :items-per-page="5"
          class="elevation-2"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="routeToProject(item)">
              mdi-file-find
            </v-icon>
            <v-icon small class="mr-2" @click="setEditProject(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="confirmDeleteProject(item)">
              mdi-delete
            </v-icon>
            <v-icon
              v-show="item.is_owner"
              small
              @click="openAccessDialog(item)"
            >
              mdi-account
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog"
      max-width="500px"
      :persistent="projectsLoaded && !projects.length"
    >
      <v-card>
        <v-card-title>{{ projectModalTitle }}</v-card-title>
        <v-card-text>
          <v-alert dense outlined type="error" v-show="errors.length">
            <ul>
              <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </v-alert>
          <v-form>
            <v-select
              :items="projectTypes"
              :menu-props="{ maxHeight: '400' }"
              label="Type *"
              :item-text="(item) => item.name"
              item-value="id"
              persistent-hint
              @change="onTypeChange"
              v-show="!isEdit"
              v-model="selectedProjectType"
            >
            </v-select>
            <v-text-field label="Name *" v-model="name"></v-text-field>
            <v-text-field
              label="Eik *"
              v-show="isCompany"
              v-model="eik"
            ></v-text-field>
            <v-text-field
              label="Bulstat *"
              v-show="isCompany"
              v-model="bulstat"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialog = false"
            v-show="projectsLoaded && projects.length"
            >Close</v-btn
          >
          <v-btn color="primary" @click="updateProject">{{
            projectModalActionButton
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="accessDialogIsOpen" max-width="700px">
      <v-card>
        <v-card-title>Add user to {{ accessDialogProjectName }}</v-card-title>
        <v-card-text>
          <v-form>
            <v-select
              v-model="accessDialogSelectedUserId"
              :items="users"
              :menu-props="{ maxHeight: '400' }"
              label="Users"
              :item-text="
                (item) =>
                  item.first_name +
                  ' ' +
                  item.last_name +
                  ' (' +
                  item.email +
                  ')'
              "
              :item-value="(item) => item.id"
              persistent-hint
            >
            </v-select>
            <v-data-table
              :headers="userHeaders"
              :items="projectUsers"
              :items-per-page="5"
              class="elevation-2"
            >
              <template v-slot:item.actions="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="deleteUserFromProject(item)"
                  v-if="!item.is_owner"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="accessDialogIsOpen = false">Close</v-btn>
          <v-btn color="primary" @click="addUserToProject">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Please confirm</v-card-title>

        <v-card-text> You are about to delete this project. </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="deleteDialog = false"> Close </v-btn>

          <v-btn color="green darken-1" text @click="deleteProject">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      projectTypes: [
        {
          id: "family",
          name: "Family",
        },
        {
          id: "company",
          name: "Company",
        },
      ],
      dialog: false,
      isFamily: false,
      isCompany: false,
      showSuccessAlert: false,
      showDeleteSuccessAlert: false,
      showUpdateAlert: false,
      deleteDialog: false,
      isEdit: false,
      name: "",
      eik: "",
      bulstat: "",
      errors: [],
      deleteErrors: [],
      activeItem: null,
      headers: [
        { text: "ID", value: "project_id" },
        { text: "Name", value: "name" },
        { text: "Type", value: "type" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      accessDialogSelectedUserId: "",
      accessDialogProjectId: null,
      accessDialogIsOpen: false,
      userHeaders: [
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Is Owner", value: "is_owner" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      selectedProjectType: null,
    };
  },
  created() {
    if (!this.projects.length) {
      this.dialog = true;
    }

    this.$store.dispatch("loadUsers");
  },
  watch: {
    projectsLoaded(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }

      if (!this.projects.length) {
        this.dialog = true;
      }
    },
  },
  computed: {
    ...mapGetters(["projects", "projectsLoaded", "users"]),
    projectModalTitle() {
      if (this.isEdit) {
        return "Edit project: " + this.activeItem.name;
      }
      return "Add new project";
    },
    projectModalActionButton() {
      if (this.isEdit) {
        return "Update";
      }
      return "Add";
    },
    projectUsers() {
      if (!this.accessDialogProjectId) return [];
      const project = this.projects.find(
        (i) => i.project_id === this.accessDialogProjectId
      );

      if (!project) return [];
      return project.users;
    },
    accessDialogProjectName() {
      if (!this.accessDialogProjectId) return [];
      const project = this.projects.find(
        (i) => i.project_id === this.accessDialogProjectId
      );

      if (!project) return [];
      return project.name;
    },
  },
  methods: {
    openProjectDialog() {
      this.dialog = true;
      this.isEdit = false;
      this.resetModel();
    },
    resetModel() {
      this.activeItem = null;
      this.isCompany = false;
      this.isFamily = false; // Assuming you might want to track 'isFamily' similar to 'isCompany'
      this.name = "";
      this.eik = "";
      this.bulstat = "";
      this.errors = []; // Reset errors when closing the dialog
      this.showSuccessAlert = false; // Reset success alert when closing the dialog
      this.showUpdateAlert = false; // Reset update alert when closing the dialog
      this.deleteErrors = []; // Reset delete errors if needed
      // Add a line to reset the project type selection. You might need a new data property for that.
      // Assuming `selectedProjectType` is your model for the project type selection.
      this.selectedProjectType = null; // Reset project type selection
    },
    deleteUserFromProject(item) {
      const { membershipId } = item;
      this.$store
        .dispatch("deleteUserFromProject", { membershipId })
        .then(() => {
          this.accessDialogProjectId = null;
          this.accessDialogIsOpen = false;
          this.accessDialogSelectedUserId = "";
          this.resetModel();
        })
        .catch((result) => {
          this.parseErrors(result);
        });
    },
    parseErrors(result) {
      var errors = result.response.data.errors;
      let keys = Object.keys(errors);
      this.errors = [];

      keys.forEach((key) => {
        let item = errors[key];
        item.forEach((error) => {
          this.errors.push(error);
        });
      });
    },
    onTypeChange(item) {
      this.isCompany = item === "company";
    },
    updateProject() {
      if (this.isEdit) {
        this.isCompany = this.activeItem.type === "company";
      }

      const data = {
        name: this.name,
      };

      if (this.isCompany) {
        data["eik"] = this.eik;
        data["bulstat"] = this.bulstat;
      }

      if (this.isEdit) {
        this.$store
          .dispatch(
            this.isCompany ? "updateCompanyProject" : "updateFamilyProject",
            { id: this.activeItem.object_id, data: data }
          )
          .then(() => {
            this.dialog = false;
            this.showUpdateAlert = true;
            this.isEdit = false;
            this.resetModel();
            this.$store.dispatch("loadAccounts", true);
            this.$store.dispatch("loadTransactionCategories", true);
            this.$store.dispatch("loadTransactionTreeViewCategories", true);
          })
          .catch((result) => {
            this.parseErrors(result);
          });
      } else {
        this.$store
          .dispatch(
            this.isCompany ? "createCompanyProject" : "createFamilyProject",
            data
          )
          .then(() => {
            this.dialog = false;
            this.showSuccessAlert = true;
            this.resetModel();
            this.$store.dispatch("loadAccounts", true);
            this.$store.dispatch("loadTransactionCategories", true);
            this.$store.dispatch("loadTransactionTreeViewCategories", true);
          })
          .catch((result) => {
            this.parseErrors(result);
          });
      }
    },
    setEditProject(item) {
      this.activeItem = item;
      this.isEdit = true;
      this.name = item.name;
      this.eik = item.eik;
      this.bulstat = item.bulstat;
      this.dialog = true;
      this.isCompany = item.type === "company";
    },
    confirmDeleteProject(item) {
      this.activeItem = item;
      this.deleteDialog = true;
    },
    openAccessDialog(item) {
      this.accessDialogProjectId = item.project_id;
      this.accessDialogIsOpen = true;
    },
    addUserToProject() {
      var data = {
        user_id: this.accessDialogSelectedUserId,
        project_id: this.accessDialogProjectId,
      };
      this.$store
        .dispatch("addUserToProject", data)
        .then(() => {
          this.accessDialogProjectId = null;
          this.accessDialogIsOpen = false;
          this.accessDialogSelectedUserId = "";
          this.resetModel();
        })
        .catch((result) => {
          this.parseErrors(result);
        });
    },
    deleteProject() {
      this.$store
        .dispatch(
          this.activeItem.type === "company"
            ? "deleteCompanyProject"
            : "deleteFamilyProject",
          this.activeItem.object_id
        )
        .then(() => {
          this.showDeleteSuccessAlert = true;
          this.deleteDialog = false;
          this.activeItem = null;
        })
        .catch((result) => {
          var errors = result.response.data.errors;
          let keys = Object.keys(errors);
          this.deleteErrors = [];

          keys.forEach((key) => {
            let item = errors[key];
            item.forEach((error) => {
              this.deleteErrors.push(error);
            });
          });
        });
    },
    routeToProject(item) {
      this.$router.push({ name: "projects", params: { id: item.project_id } });
    },
  },
};
</script>
